import React, { useEffect, useState } from 'react';
import './Profile.css';
import { useNavigate } from 'react-router-dom';
import { assets } from '../../../assets/assets';
import Navbar from '../Navbar/Navbar';
import { Bars } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import toastService from '../../../services/toastService';
import { postData } from '../../../services/apiServices';
import Loader from '../../MyComponents/Loader/Loader';


function Profile() {
    const userInfo = useSelector((state) => state.user.userInfo);
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [profileImage, setProfileImage] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProfileData()
    }, []);

    const navigate = useNavigate();

    const handleSignIn = (event) => {
        event.preventDefault();

    };

    const getProfileData = async () => {
        setIsLoading(true)
        const data = {
            verification_token: "123456",
            table: "Users",
            "id": userInfo?.id
        }
        try {
            const result = await postData("/get", data)
            console.log(result, "this is the profile data form the api php")
            if (result?.message === "success") {
                setIsLoading(false)
                const mydata = result?.data[0]
                setFirstName(mydata?.firstname)
                setLastName(mydata?.lastname)
                setEmail(mydata?.email)
                setPhone(mydata?.phone)
                setProfileImage(mydata?.userImage)

            } else {
                toastService.showError(result?.message)

                setIsLoading(false)

            }
        } catch (error) {
            console.log(error)
            toastService.showError("Something went wrong")
            setIsLoading(false)
        }
    }

    // const handleImageChange = (event) => {
    //     if (event.target.files && event.target.files[0]) {
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             setProfileImage(e.target.result); // Set the selected image
    //         };
    //         reader.readAsDataURL(event.target.files[0]);
    //     }
    // };


    const handleImageUpload = async (event) => {
        const file = event.target.files[0];  
        if (!file) {
            toastService.showError('No image selected');
            return;
        }

        // Creating a FormData object to send the image
        const formData = new FormData();
        formData.append('verification_token', '123456');
        formData.append('files_upload', file);  

        try {
             for (let pair of formData.entries()) {
                console.log(`${pair[0]}:`, pair[1]);  
            }

             const response = await fetch('https://appvelo.com/realestateOfferAPI/fileupload', {
                method: 'POST',
                body: formData,
             });

            const result = await response.json();
            console.log(result , "AD>A>#>$>#$")
            if (result.message === 'success') {
                setProfileImage(result.url); 
                toastService.showSuccess('Image uploaded successfully');
            } else {
                toastService.showError(result.message || 'Image upload failed');
            }
        } catch (error) {
            console.error('Error uploading image:', error);
            toastService.showError('Image upload failed');
        }
    };

    const updateUserProfile = async (event) => {
        event.preventDefault();
        setIsLoading(true)
        const data = {
            "userid": userInfo?.id,
            "firstname": firstName,
            "lastname": lastName,
            "email": email,
            "phone": phone,
            "usertype": userInfo?.usertype,
            "status": "active",
            "verification_token": "123456",
            "userImage" : profileImage
        }
        try {
            const result = await postData("/edit_user", data)
            if (result?.message === "success") {
                setIsLoading(false)
                toastService.showSuccess("Profile Updated Successfully")

                getProfileData()
            } else {
                toastService.showError(result?.message)

                setIsLoading(false)
            }
        } catch (error) {
            console.log(error)
            toastService.showError("Something went wrong")
            setIsLoading(false)
        }
    }

    return (
        <>
         <Loader isLoading={isLoading}   />
                    <Navbar />
                    <div className="containers">
                        <div className="signin-container">
                            <div className="signin-form">
                                <div className="signin-form1">
                                    <div className="profile-image-maindiv">
                                        <img className="profile-img" src={profileImage} alt="Profile" />
                                        <label className="camera-icon">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageUpload}
                                                style={{ display: 'none' }}
                                            />
                                            <img src={assets.CameraImg} alt="Camera" />
                                        </label>
                                    </div>
                                    <form onSubmit={updateUserProfile}>
                                        <div className="input-field">
                                            <div className="input-wrapper">
                                                <i className="fas fa-envelope"></i>
                                                <input
                                                    type="text"
                                                    id="firstName"
                                                    placeholder="Enter First Name"
                                                    value={firstName}
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="input-field">
                                            <div className="input-wrapper">
                                                <i className="fas fa-envelope"></i>
                                                <input
                                                    type="text"
                                                    id="lastName"
                                                    placeholder="Enter Last Name"
                                                    value={lastName}
                                                    onChange={(e) => setLastName(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="input-field">
                                            <div className="input-wrapper">
                                                <i className="fas fa-envelope"></i>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    placeholder="Enter Email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="input-field">
                                            <div className="input-wrapper">
                                                <i className="fas fa-lock"></i>
                                                <input
                                                    type={'text'}
                                                    id="phone"
                                                    placeholder="Enter Phone Number"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <button type="submit">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
          
    );
}

export default Profile;
